import { ICoverData } from './cover-data.interface';
import { ICustomerData } from './customer-data.interface';
import { IOptions } from './options.interface';
import { IOrganizationData } from './organization-data.interface';
import { ISectionData } from './section-data.interface';
import { ISignatureData } from './signature-data.interface';

export interface IPrintData {
    coverData: ICoverData;
    customerData: ICustomerData;
    organizationData: IOrganizationData;
    options: IOptions;
    signatures: ISignatureData;
    date: string;
    sections: ISectionData[];
    text: {};
}
